import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root'
})
export class ReachusService {

  constructor(private crudService: CrudService) { }

  Save(model: any): Observable<any> {
    debugger;
    return this.crudService.post<any>('api/ReachUs/Save', model);
  }

}
